export default __webpack_public_path__ + "static/woa-ro-0bb0d7f214b2b436d5981b30cc417ae5.png";